import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "Notificacao";

export const ListarNotificacoesUsuario = () =>
  RequestWebApi.get(`/${controller}/ListarNotificacoesUsuario`)
    .then(function (response) {
      const { resultData, success } = response.data;
      const notificacaos = resultData;
      return { success, notificacaos };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { notificacaos: [] };
    });

export const ObterTotalNotificacoesNaoLidas = () =>
  RequestWebApi.get(`/${controller}/ObterTotalNotificacoesNaoLidas`)
    .then(function (response) {
      const { resultData, success } = response.data;
      const totalNotificacao = resultData;
      return { success, totalNotificacao };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { totalNotificacao: 0 };
    });


export const MarcarComoLido = (notificacao) =>
  RequestWebApi.put(`/${controller}/MarcarComoLido`, notificacao)
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

